<template>
	<div>
		<!-- Header -->
		<appHeader></appHeader>
	
		<!-- Body -->
		<appBody></appBody>
	
		<!--Footer  -->
		<appFooter></appFooter>
	</div>
</template>

<script>
	import Header from "./components/Header";
	import Body   from "./components/Body";
	import Footer from "./components/Footer";

export default {
	components: {
		appHeader: Header,
		appBody:   Body,
		appFooter: Footer,
	}
}
</script>

<style>
	@import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@300;400&display=swap');
	
	/* Sticky footer styles */
	html {
		background-color: #000;
		position: relative;
		min-height: 100%;
	}

	/* Bootsrap mod styles */
	body {
		font-family: 'Ubuntu', sans-serif;
		background-color: #000;
		color: #bbb;
		/* Margin bottom by footer height */
		margin-bottom: 60px;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue